module.exports = __webpack_public_path__ + "img/pesaj-2020.e59e4afc.jpeg";